const BASE_ZINDEX = {
  mobile: 1e5,
  // due forum mobile dialog zindex
  desktop: 5e3
  //photo sutdio zindex - 6000, MM zindex - 10000
};
const zIndexLayers = {
  TOOLBAR: 100,
  POPUP: 200,
  DRAWER: 300,
  DIALOG: 300,
  TOOLTIP: 400,
  NOTIFICATION: 500
};
class ZIndexService {
  constructor(isMobile, settingsStyles) {
    this.baseZIndex = isMobile ? BASE_ZINDEX.mobile : BASE_ZINDEX.desktop;
    this.settingsStyles = settingsStyles;
  }
  layerToCssVar(layer) {
    var _a;
    if (!this.settingsStyles || !((_a = this.settingsStyles) == null ? void 0 : _a.modals)) {
      return void 0;
    }
    return `--ricos-settings-modals-${layer.toLowerCase()}-z-index`;
  }
  getZIndex(layer) {
    const defaultValue = this.baseZIndex + zIndexLayers[layer];
    const themeLayerValue = this.layerToCssVar(layer);
    return themeLayerValue !== void 0 ? `var(${themeLayerValue}, ${defaultValue})` : defaultValue;
  }
}

export { ZIndexService };
//# sourceMappingURL=z-index-service.js.map
